import React from 'react';
import { Box, Card, Heading, Paragraph, Text, ToggleButton, ToggleButtonGroup } from '@zillow/constellation-10';

// Components
import OutputCard from './OutputCard';
import InputAndSlider from './InputAndSlider';

// Misc / Utils
import { outputsPairContainerStyles, returnStyles } from './styles';
import { useCalculator } from './hooks';

interface RoiCalculatorProps {
  itc: string;
  t: string;
  heading: string;
  subheading: string;
}
/* eslint-disable @typescript-eslint/no-unused-vars */
const RoiCalc: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<RoiCalculatorProps>>> = ({
  itc = '',
  t = '',
  heading = 'Rental Property ROI Calculator',
  subheading = 'Calculate your potential return on investment',
}: RoiCalculatorProps) => {
  /* eslint-enable */
  const { inputs, outputs, years, setYears, totalReturn } = useCalculator();

  const handleSelectYears = (value: string) => {
    setYears(value);
  };

  return (
    // oxlint-disable-next-line constellation/no-raw-spacing-values -- `maxWidth: 800px` is past the end of the numeric sizes scale, which stops at `5000` (200px)
    <Card tone="neutral" elevated={true} css={{ width: '100%', maxWidth: '800px', margin: 'auto' }}>
      <Heading level={2} textStyle="heading-sm">
        {heading}
      </Heading>
      <Paragraph textStyle="body-sm" css={{ marginBottom: '200' }}>
        {subheading}
      </Paragraph>
      <Box css={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
        {inputs.map((inputObj, i) => (
          <InputAndSlider key={i} {...inputObj} />
        ))}
      </Box>
      <ToggleButtonGroup
        defaultValue={years.toString()}
        onValueChange={(value) => handleSelectYears(value as string)}
        css={{ paddingBlock: '400' }}
        aria-label="Years"
      >
        <ToggleButton value="5" css={{ width: '100%', mdDown: { paddingBlock: '300' } }}>
          5 years
        </ToggleButton>
        <ToggleButton value="10" css={{ width: '100%', mdDown: { paddingBlock: '300' } }}>
          10 years
        </ToggleButton>
        <ToggleButton value="20" css={{ width: '100%', mdDown: { paddingBlock: '300' } }}>
          20 years
        </ToggleButton>
        <ToggleButton value="30" css={{ width: '100%', mdDown: { paddingBlock: '300' } }}>
          30 years
        </ToggleButton>
      </ToggleButtonGroup>
      <Box
        css={{
          display: 'flex',
          flexDirection: { base: 'column', md: 'row' },
          paddingTop: { base: '0', md: '600' },
        }}
      >
        <Box css={outputsPairContainerStyles}>
          {outputs.slice(0, 2).map((outputObj, i) => (
            <OutputCard key={i} {...outputObj} />
          ))}
        </Box>
        <Box css={outputsPairContainerStyles}>
          {outputs.slice(2, 4).map((outputObj, i) => (
            <OutputCard key={i} {...outputObj} />
          ))}
        </Box>
      </Box>
      <Box css={returnStyles}>
        <Text>Total return: </Text>
        <Text textStyle="heading-md" css={{ marginLeft: '600' }}>
          {totalReturn}
        </Text>
      </Box>
    </Card>
  );
};

export default RoiCalc;
